import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

import type { CustomerActiveRewardsEntity } from "../models/RewardsCustomerRewardsEntities";

export interface CustomerActiveRewardsState {
    customerActiveRewardsList: CustomerActiveRewardsEntity[];
}

const createInitialState = (): CustomerActiveRewardsState => ({
    customerActiveRewardsList: [],
});

@singleton()
@StoreConfig({ name: "RewardsCustomerActiveRewardsStore" })
class RewardsCustomerActiveRewardsStore extends BaseStore<CustomerActiveRewardsState> {
    constructor() {
        super(createInitialState());
    }
}

export default RewardsCustomerActiveRewardsStore;
